/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetNewbuildingsForSerpModel,
  IGetNewbuildingsForSerpRequest,
  IMappers,
  IGetNewbuildingsForSerpResponse,
  IGetNewbuildingsForSerpResponseError,
  TGetNewbuildingsForSerpResponse,
} from './types';

const defaultConfig: TGetNewbuildingsForSerpModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'newbuilding-search',
  pathApi: '/v1/get-newbuildings-for-serp/',
  hostType: 'api',
} as TGetNewbuildingsForSerpModel;

function createGetNewbuildingsForSerpModel(parameters: IGetNewbuildingsForSerpRequest): TGetNewbuildingsForSerpModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetNewbuildingsForSerpOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetNewbuildingsForSerpRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetNewbuildingsForSerp<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetNewbuildingsForSerpOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetNewbuildingsForSerpResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetNewbuildingsForSerpModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetNewbuildingsForSerpResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetNewbuildingsForSerpResponseError);
    }
  }

  return { response, statusCode } as TGetNewbuildingsForSerpResponse;
}

export { defaultConfig, createGetNewbuildingsForSerpModel, fetchGetNewbuildingsForSerp };
